<div
  class="protocol"
>
  <h2>
    BACnet/IP
  </h2>

  <div
    class="methods"
  >
    <div
      class="method alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="discoveringBacnetDevices = true"
    >
      <div
        class="middle-content"
      >
        <motn-fa-icon [icon]="'fa-regular fa-radar'"></motn-fa-icon>
      </div>

      <div
        class="bottom-content"
      >
        Device Discovery
      </div>
    </div>

    <div
      class="method alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="openManualEntry(DeviceType.BACnet)"
    >
      <div
        class="middle-content"
      >
        <motn-fa-icon [icon]="'fa-regular fa-keyboard'"></motn-fa-icon>
      </div>

      <div
        class="bottom-content"
      >
        Manual Entry
      </div>
    </div>
  </div>
</div>

<div
  class="protocol"
>
  <h2>
    Modbus TCP
  </h2>

  <div
    class="methods"
  >
    <div
      class="method alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="openManualEntry(DeviceType.Modbus)"
    >
      <div
        class="middle-content"
      >
        <motn-fa-icon [icon]="'fa-regular fa-keyboard'"></motn-fa-icon>
      </div>

      <div
        class="bottom-content"
      >
        Manual Entry
      </div>
    </div>
  </div>
</div>

<div
  class="protocol"
>
  <h2>
    LoRaWAN
  </h2>

  <div
    class="methods"
  >
    <div
      class="method alt-color"
      [attr.data-color]="'indigo-white'"
      (click)="handleOTAAClick()"
    >
      <div
        class="middle-content"
      >
        @if (loadingLoRaWANHubs) {
          <motn-spinner></motn-spinner>
        } @else {
          <motn-fa-icon [icon]="'fa-regular fa-signal-stream'"></motn-fa-icon>
        }
      </div>

      <div
        class="bottom-content"
      >
        OTAA
      </div>
    </div>
  </div>
</div>

@if (discoveringBacnetDevices) {
  <motn-bacnet-device-discovery
    (clickedOutside)="discoveringBacnetDevices = false"
  ></motn-bacnet-device-discovery>
}

@if (manuallyEnteringProtocol) {
  <motn-device-editor
    [protocol]="manuallyEnteringProtocol"
    (clickedOutside$)="manuallyEnteringProtocol = null"
  ></motn-device-editor>
}
